/* eslint-disable camelcase */
export const tableRoutes = {
  broadband_homepage: '/broadband',
  broadband_results: '/broadband/results',
  tv_homepage: '/tv',
  broadband_packages: '/broadband/packages',
  mobile_broadband: '/broadband/mobile-broadband',
  fibre_optic: '/broadband/compare/fibre_optic',
  home_phone_and_international_calls: '/broadband/compare/home_phone_and_international_calls',
  free_router: '/broadband/compare/free_router',
  broadband_with_free_gifts: '/broadband/compare/broadband_with_free_gifts',
  student_broadband: '/broadband/student-broadband',
  unlimited_broadband: '/broadband/unlimited-broadband',
  broadband_and_free_line_rental: '/broadband/broadband-and-free-line-rental',
  business_broadband: '/broadband/business-broadband',
  home_phone_and_landline: '/broadband/compare/home_phone_and_landline',
  broadband_and_digital_tv: '/broadband/compare/broadband_and_digital_tv',
  broadband_and_home_phone: '/broadband/broadband-and-home-phone',
  cheap_broadband: '/broadband/cheap-broadband',
  broadband_only: '/broadband/broadband-only',
  wireless_broadband: '/broadband/wireless-broadband',
  free_broadband: '/broadband/no-upfront-cost-broadband',
  bt: '/broadband/providers/bt',
  ee: '/broadband/providers/ee',
  talktalk: '/broadband/providers/talktalk',
  talktalk_business: '/broadband/providers/talktalk_business',
  plusnet: '/broadband/providers/plusnet',
  plusnet_business: '/broadband/providers/plusnet_business',
  sky: '/broadband/providers/sky',
  virgin_media: '/broadband/providers/virgin_media',
  virgin_media_business: '/broadband/providers/virgin_media_business',
  vodafone: '/broadband/providers/vodafone',
  now_broadband: '/broadband/providers/now_broadband',
  dst: '/broadband/providers/dst',
  xln_telecom: '/broadband/providers/xln_telecom',
  john_lewis_broadband: '/broadband/providers/john_lewis_broadband',
  hyperoptic: '/broadband/providers/hyperoptic',
  pop_telecom: '/broadband/providers/pop_telecom',
  sse: '/broadband/providers/sse',
  origin: '/broadband/providers/origin',
  onestream: '/broadband/providers/onestream',
  shell_energy_broadband: '/broadband/providers/shell_energy_broadband',
  postcode_checker_results: '/broadband/postcode_checker/results',
  postcode_checker_results_tv: '/tv/postcode_checker/results',
  tv_packages: '/tv/packages',
  tv_now_tv: '/tv/providers/now',
  tv_talktalk: '/tv/providers/talktalk',
  tv_sky: '/tv/providers/sky',
  tv_virgin_media: '/tv/providers/virgin_media',
  tv_ee: '/tv/providers/ee',
  tv_bt: '/tv/providers/bt',
  tv_pop_telecom: '/tv/providers/pop_telecom',
  amazon: '/tv/providers/amazon',
  black_friday: '/broadband/compare/black_friday',
  black_friday_tv: '/broadband/compare/black_friday_bb_and_tv',
  local_hull: '/broadband/local/hull',
  hull_results: '/broadband/local/hull/results',
  london: '/broadband/local/london',
  oxford: '/broadband/local/oxford',
  aberdeen: '/broadband/local/aberdeen',
  bristol: '/broadband/local/bristol',
  edinburgh: '/broadband/local/edinburgh',
  leeds: '/broadband/local/leeds',
  belfast: '/broadband/local/belfast',
  exeter: '/broadband/local/exeter',
  nottingham: '/broadband/local/nottingham',
  norwich: '/broadband/local/norwich',
  brighton: '/broadband/local/brighton',
  cardiff: '/broadband/local/cardiff',
  glasgow: '/broadband/local/glasgow',
  manchester: '/broadband/local/manchester',
  community_fibre: '/broadband/providers/community_fibre',
  cuckoo: '/broadband/providers/cuckoo',
  kcom: '/broadband/providers/kcom',
  gigaclear: '/broadband/providers/gigaclear'
}

export const nonTableRoutes = {
  providers: '/broadband/providers/',
  postcode_checker_landing: '/broadband/postcode_checker/',
  tv_postcode_checker_landing: '/tv/postcode_checker/',
  tv_providers: '/tv/providers',
  broadband_products: '/broadband/products',
  local_landing: '/broadband/local/',
  journey: '/broadband/journey'
}

export const routesNotTest = [
  'broadband_and_digital_tv',
  'broadband_and_home_phone',
  'cheap_broadband',
  'broadband_only',
  'wireless_broadband',
  'plusnet',
  'sky',
  'virgin_media',
  'student_broadband',
  'vodafone',
  'now_broadband',
  'dst',
  'xln_telecom',
  'john_lewis_broadband',
  'hyperoptic',
  'pop_telecom',
  'sse',
  'origin',
  'onestream',
  'shell_energy_broadband',
  'tv_now_tv',
  'broadband_and_free_line_rental',
  'free_broadband',
  'unlimited_broadband'
]

export default {
  ...tableRoutes,
  ...nonTableRoutes
}
